export default __webpack_public_path__ + "static/media/lineTheme.fea294a5.jpg";